(function($) {
    if (!document.querySelector('body.gp-endpoint-pos-order')) {
        return;
    }

    $(document).on('click.posAjax', '[data-pos-order-ajax]', function(e){
        e.preventDefault();

        const $btn   = $(this);
        const ajaxUrl = $btn.data('posOrderAjax') || $btn.attr('data-pos-order-ajax');
        const action  = $btn.data('action')        || $btn.attr('data-action');
        const orderId = parseInt( $btn.data('orderId') || $btn.attr('data-order-id'), 10 );

        function error(message) {
            alert(message || 'Chyba komunikace');
        }

        const payload = {
            order_id:   parseInt(orderId, 10),
            pos_action: action
        };

        if (action === 'preprepare') {
            let raw = $btn.attr('data-variants');
            try {
                payload.variants = raw ? JSON.parse(raw) : [];
            } catch (err) {
                console.error('Invalid variants JSON:', raw);
                payload.variants = [];
            }
        }

        if (action === 'mark_missing') {
            payload.variant_id = parseInt($btn.attr('data-variant-id'), 10);
        }
        $btn.prop('disabled', true).addClass('is-loading');
        gp_ajax({
            url:      ajaxUrl,
            type:     "post",
            dataType: "json",
            data:     payload
        })
            .done((response) => {
                if (!response.success) {
                    return error(response.data?.error);
                }
                $(document).trigger('close_modal');
                const redirect = response.data?.redirect_url;
                if (redirect) {
                    window.location = redirect;
                } else {
                    location.reload();
                }
            })
            .fail(() => {
                error();
            });
    });
    $(document).on('click',
        '[data-modal-id="pos-order-pre-prepared"],' +
        '[data-modal-id="pos-order-found"],' +
        '[data-modal-id="pos-order-prepared"]',
        function(e){
            e.preventDefault();
            $(document).trigger('close_modal');
        }
    );
})(jQuery);
